import { render, staticRenderFns } from "./WsErrorMessage.vue?vue&type=template&id=2e88d2a2&"
import script from "./WsErrorMessage.vue?vue&type=script&lang=js&"
export * from "./WsErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports